import { housekeepingQueryKeys as e } from "./useHousekeepingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { housekeepingApi as n } from "@maat/api-main";
//#region src/housekeeping/useRoomStatusBoardQuery.ts
var r = (r, i, a) => t({
	queryKey: e.board(r, i),
	queryFn: () => n.getRoomStatusBoard(r, i ? { date: i } : {}),
	enabled: !!r && (a?.enabled ?? !0),
	staleTime: 3e4
});
//#endregion
export { r as useRoomStatusBoardQuery };
